import {NgModule} from "@angular/core";
import {INT_NOTIFICATIONS_PROVIDER} from "./int-notifications.provider";
import { NotificationRootComponent } from './components/notification-root/notification-root.component';
import {IntDefaultNotificationModule} from "../../components/notifications";
import {CommonModule} from "@angular/common";
import {IntPortalOutletModule} from "../portal-outlet";


@NgModule({
  imports: [
    IntDefaultNotificationModule,
    CommonModule,
    IntPortalOutletModule
  ],
  providers: [
    INT_NOTIFICATIONS_PROVIDER
  ],
  declarations: [
    NotificationRootComponent,

  ],
  exports: [
    NotificationRootComponent
  ]
})
export class IntNotificationsModule {}
